document.querySelectorAll('.ApartmentsListTable__item').forEach((el) => {
    const img = el.querySelector('.ApartmentsListTable__item-img-prev');

    el.querySelectorAll('img').forEach((item) => {
        const src = item.dataset.src || item.src;

        item.addEventListener('mouseenter', () => {
            img.src = src;
            img.classList.add('active');
        });
        item.addEventListener('mouseleave', () => {
            if(img.src === src) {
                img.src = '';
                img.classList.remove('active');
            }
        });
    })
})
